<div class="width-fifty pb-2 section">
    <div class="retour oneLine mt-1">
        <span>&#60;</span>
        <button (click)="retour()">{{ preferenceMessages.tab_6_retour | translate }}</button>
    </div>
    <div class="mt-3">
        <div class="oneLine" *ngIf="action === 'ajouter'">
            <h2>{{ preferenceMessages.tab_6_label_3 | translate }}</h2>
            <app-partage-preference [isAcheteur]="true"
                (preferenceCopied)="partageReturn($event)"></app-partage-preference>
        </div>
        <h2 *ngIf="action === 'modifier'">{{ preferenceMessages.tab_6_label_4 | translate }}</h2>
    </div>
    <div class="content">
        <div class="form">
            <div class="oneLine mt-3">
                <p>{{ preferenceMessages.tab_2_label_6_part1 | translate }}</p>
                <p class="red">&nbsp;*&nbsp;</p>
                <p>{{ preferenceMessages.tab_2_label_6_part2 | translate }}</p>
            </div>
            <form class="myForm" [formGroup]="form">
                <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_6_label_intitule | translate"
                    [type]="'text'" [rule]="'required'" [name]="'preference_SepAtt_acheteur_SepAtt_intitule'">
                </app-form-input>
                
                <div class="group">
                    <h1>{{preferenceMessages.tab_6_sous_titre_1 | translate}}</h1>
                    <div class="fields">
                        <app-form-input [parentForm]="form"
                            [label]="preferenceMessages.tab_6_label_personne_physique | translate" [type]="'radio'"
                            [value]="radioButtonValue"
                            [radios]="[
                             {
                               value: true,
                               label: ouiValue
                             },
                             {
                               value: false,
                               label: nonValue
                             }]"
                             [name]="'preference_SepAtt_acheteur_SepAtt_personne_physique'">
                        </app-form-input>
                        <app-form-input [parentForm]="form"
                            [label]="preferenceMessages.tab_6_label_nom_officiel | translate" [type]="'text'"
                            [name]="'preference_SepAtt_acheteur_SepAtt_nom_officiel'" [rule]="'required'">
                        </app-form-input>
                        <app-form-input [parentForm]="form"
                            [label]="preferenceMessages.tab_6_label_num_enregistrement | translate" [type]="'text'"
                            [name]="'preference_SepAtt_acheteur_SepAtt_num_enregistrement'" [rule]="'required'">
                        </app-form-input>
                        <app-form-input [parentForm]="form"
                            [label]="preferenceMessages.tab_6_label_departement | translate" [type]="'text'"
                            [name]="'preference_SepAtt_acheteur_SepAtt_departement'">
                        </app-form-input>
                        <app-form-input [parentForm]="form"
                            [label]="preferenceMessages.tab_6_label_adresse_internet | translate" [type]="'text'"
                            [name]="'preference_SepAtt_acheteur_SepAtt_adresse_internet'"
                            [placeholder]="'eform-editable.placeholder.BT-505-Organization-company'| translate">
                        </app-form-input>
                        <app-form-input [parentForm]="form"
                            [label]="preferenceMessages.tab_6_label_url_echange_information | translate" [type]="'text'"
                            [name]="'preference_SepAtt_acheteur_SepAtt_url_echange_information'"
                            [placeholder]="'eform-editable.placeholder.BT-509-organization-company'| translate">
                        </app-form-input>
                    </div>
                </div>
                <div class="group">
                    <h1>{{preferenceMessages.tab_6_sous_titre_2 | translate}}</h1>
                    <div class="fields">
                        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_6_label_Adr1 | translate"
                            [type]="'text'" [name]="'preference_SepAtt_acheteur_SepAtt_Adr1'">
                        </app-form-input>
                        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_6_label_Adr2 | translate"
                            [type]="'text'" [name]="'preference_SepAtt_acheteur_SepAtt_Adr2'">
                        </app-form-input>
                        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_6_label_Adr3 | translate"
                            [type]="'text'" [name]="'preference_SepAtt_acheteur_SepAtt_Adr3'">
                        </app-form-input>
                        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_6_label_ville | translate"
                            [type]="'text'" [name]="'preference_SepAtt_acheteur_SepAtt_ville'" [rule]="'required'">
                        </app-form-input>
                        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_6_label_cp | translate"
                            [type]="'text'" [name]="'preference_SepAtt_acheteur_SepAtt_cp'">
                        </app-form-input>
                        <app-form-input [parentForm]="form" class="input-with-button"
                            [label]="preferenceMessages.tab_6_label_entite_secondaire | translate" [type]="'select'"
                            [name]="'preference_SepAtt_acheteur_SepAtt_entite_secondaire'" [optionsWithCode]="optionsNuts" 
                            (click)="openModalOtherOption()">
                        </app-form-input>
                        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_6_label_pays | translate"
                            [type]="'select'" [name]="'preference_SepAtt_acheteur_SepAtt_pays'" [rule]="'required'"
                            [optionsWithCode]="optionsPays">
                        </app-form-input>
                    </div>
                </div>

                <div class="group">
                    <h1>{{preferenceMessages.tab_6_sous_titre_3 | translate}}</h1>
                    <div class="fields">
                        <app-form-input [parentForm]="form"
                            [label]="preferenceMessages.tab_6_label_point_contact | translate" [type]="'text'"
                            [name]="'preference_SepAtt_acheteur_SepAtt_point_contact'">
                        </app-form-input>
                        <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_6_label_email | translate"
                            [type]="'text'" [name]="'preference_SepAtt_acheteur_SepAtt_email'" [rule]="'required'"
                            [placeholder]="'eform-editable.placeholder.BT-506-Organization-company'| translate">
                        </app-form-input>
                        <app-form-input [parentForm]="form"
                            [label]="preferenceMessages.tab_6_label_telephone | translate" [type]="'text'"
                            [name]="'preference_SepAtt_acheteur_SepAtt_telephone'" [rule]="'required'"
                            [placeholder]="'eform-editable.placeholder.BT-503-Organization-company'| translate">
                        </app-form-input>
                        <app-form-input [parentForm]="form"
                            [label]="preferenceMessages.tab_6_label_telecopieur | translate" [type]="'text'"
                            [name]="'preference_SepAtt_acheteur_SepAtt_telecopieur'"
                            [placeholder]="'eform-editable.placeholder.BT-739-Organization-Company'| translate">
                        </app-form-input>
                    </div>
                </div>

                <button *ngIf="action === 'ajouter'" [disabled]="(!form.valid)" (click)="savePref()"
                    class="btn btn-primary">
                    {{ preferenceMessages.tab_6_ajouter | translate }}
                </button>
                <button *ngIf="action === 'modifier'" [disabled]="(!form.valid)" (click)="savePref()"
                    class="btn btn-primary">
                    {{ preferenceMessages.tab_6_modifier | translate }}
                </button>
                <button id="annuler" (click)="annuler()" class="btn btn-outline-primary ml-2">
                    {{ preferenceMessages.tab_4_label_annuler | translate }}
                </button>
            </form>
        </div>
    </div>
</div>